import { FC } from "react";
import { Grid } from "antd";
import dayjs from "dayjs";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { CalendarIcon } from "src/assets/Icons";
import { useTranslation } from "react-i18next";
import DepartureComponentWeb from "./layouts/DepartureComponent.web";
import DepartureComponentMob from "./layouts/DepartureComponent.mob";
import i18n from "src/i18n";

const DepartureSelectComponent = withConditionalComponent(DepartureComponentWeb, DepartureComponentMob);

const DepartureComponent: FC<{ errorFields: string[] }> = ({ errorFields }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const name = "preferredDepartureTime";
  const hasError = errorFields.includes(name);

  const fieldProps = {
    name,
    icon: CalendarIcon,
    label: t("Flights.search.departure"),
    hasError,
    rules: [
      { required: true, message: t("Flights.search.departureRequired") },
    ],
    disabledDate: (d: dayjs.Dayjs) => d.isBefore(dayjs(), "day"),
    className: "flex-5 h-15! border-none! focus-within:outline-none! focus-within:ring-0! w-full font-semibold!",
  };

  return <DepartureSelectComponent trigger={isLargeScreen} props={fieldProps} />;
};

export default DepartureComponent;
